function instanceOfAzureCredential(authType, object) {
  if (!object) {
    return false;
  }
  return object.authType === authType;
}

export { instanceOfAzureCredential };
//# sourceMappingURL=AzureCredentials.js.map
